// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9zSt5","colBig":"styles_colBig__38esP","colSmall":"styles_colSmall__3ldCl","shopifyNameWrapper":"styles_shopifyNameWrapper__aTDD9"};